import type { FormInstance } from "antd/es/form/Form";
import type { DestinationEditFormProps } from "../../../store/slices/destinations/types";
import { checkIsValidAreaCodes } from "./checkIsValidAreaCodes";

// Исходим из того, что при ручном вводе длина текста изменяется на 1, при копировать/вставить на большее число
const checkIsManualInput = (props: { value?: string; prevValue?: string }) => {
  const { value, prevValue } = props;
  const difference = (value?.length || 0) - (prevValue?.length || 0);
  if (difference === 1 || difference === -1) {
    return true;
  }
  return false;
};

interface OnChangeAreaCodesProps {
  value: string;
  form: FormInstance<DestinationEditFormProps>;
  openValidateModal: () => void;
}

/* onChangeAreaCodes: 
    Для ручного ввода: при вводе запрещенного символа, устанавливается предыдущее значение.
    Для копировать/вставить: вызывается модалка валидации.
*/
export const onChangeAreaCodes = (props: OnChangeAreaCodesProps): void => {
  const { value, form, openValidateModal } = props;
  if (!value) return;
  const prevValue = form.getFieldValue("prevAreaCodes") || "";
  const isManualInput = checkIsManualInput({ value, prevValue });
  const isValidValue = checkIsValidAreaCodes(value);
  // console.log({ value, prevValue, isValidValue, isManualInput });
  if (isValidValue) {
    form.setFieldsValue({ prevAreaCodes: value });
  } else {
    form.setFieldsValue({ areaCodes: prevValue });
    form.validateFields(["areaCodes"]);
  }
  if (!isManualInput) {
    const endsWithDash = value.endsWith("-");
    if (!isValidValue || endsWithDash) {
      openValidateModal();
    }
  }
};
